import React from 'react';

const FormInput = ({
  name,
  type = 'text',
  label,
  dataErrorMessage,
  displayError,
  value = '',
  onInputChange,
  required = false,
  maxLength,
  disabled = false,
}) => (
  <div>
    <label htmlFor={name} data-test="form-field-label">
      {label}
    </label>
    <input
      id={name}
      type={type}
      value={value}
      data-error-message={dataErrorMessage}
      onChange={onInputChange}
      className={displayError ? 'input--invalid input sessioncamexclude' : 'input sessioncamexclude'}
      name={name}
      maxLength={maxLength}
      autoComplete="on"
      aria-invalid="false"
      required={required}
      disabled={disabled}
    />
    {displayError &&
      <small className="never-knowingly-undersold-error-msg">{dataErrorMessage}</small>
    }
  </div>
);

export default FormInput;
